import { render, staticRenderFns } from "./componnet-table.vue?vue&type=template&id=28ad6fd4&scoped=true&"
import script from "./componnet-table.vue?vue&type=script&lang=js&"
export * from "./componnet-table.vue?vue&type=script&lang=js&"
import style0 from "./componnet-table.vue?vue&type=style&index=0&id=28ad6fd4&lang=less&scoped=true&"
import style1 from "./componnet-table.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ad6fd4",
  null
  
)

export default component.exports